module.exports = __webpack_public_path__ + "static/media/12A.72903f48.png";